import { Outlet } from "react-router";
import LoginFooter from "../features/login/login-footer";
import LoginHeader from "../features/login/login-header";

const Layout = () => (
	<div className="flex min-h-screen flex-col bg-[url(/src/images/hero-login.jpg)] bg-cover bg-position-[center_top_80px] bg-no-repeat">
		<LoginHeader />
		<main className={`tablet:p-32 grow flex-col items-center justify-center p-6`}>
			<Outlet />
		</main>
		<LoginFooter />
	</div>
);

export default Layout;
